// src/config/categoryConfig.js

// Map of your MongoDB category IDs → label + icon key
export const CATEGORY_CONFIG = {
  // 1) Hand Tools
  "6720b343ab1e075b95501b26": {
    id: "6720b343ab1e075b95501b26",
    slug: "tools",
    label: "Tools",
    icon: "tools",
  },

  // 2) Equipment (testing tools, foam guns, etc.)
  "6720b366ab1e075b95501b29": {
    id: "6720b366ab1e075b95501b29",
    slug: "equipment",
    label: "Equipment",
    icon: "equipment",
  },

  // 3) Painting tools (rollers)
  "6720b38eab1e075b95501b2c": {
    id: "6720b38eab1e075b95501b2c",
    slug: "painting",
    label: "Painting",
    icon: "painting",
  },

  // 4) Coatings & industrial paints
  "6720b3a6ab1e075b95501b2f": {
    id: "6720b3a6ab1e075b95501b2f",
    slug: "coatings",
    label: "Coatings",
    icon: "coatings",
  },

  // 5) Cement & building materials
  "6720b3b6ab1e075b95501b32": {
    id: "6720b3b6ab1e075b95501b32",
    slug: "cement",
    label: "Cement",
    icon: "cement",
  },

  // 6) Plumbing pipes & fittings
  "6720b3d8ab1e075b95501b35": {
    id: "6720b3d8ab1e075b95501b35",
    slug: "plumbing",
    label: "Plumbing",
    icon: "plumbing",
  },

  // 7) Safety equipment (PPE)
  "672f5151e320b180af7c62a9": {
    id: "672f5151e320b180af7c62a9",
    slug: "safety",
    label: "Safety",
    icon: "safety",
  },

  // 8) Formwork & shuttering
  "672f5ab0e320b180af7c6488": {
    id: "672f5ab0e320b180af7c6488",
    slug: "formwork",
    label: "Formwork",
    icon: "formwork",
  },

  // 9) Electricals & lighting
  "67fe287d6129d8739a1d39c1": {
    id: "67fe287d6129d8739a1d39c1",
    slug: "lighting",
    label: "Lighting",
    icon: "lighting",
  },
};

export function getCategoryMeta(categoryId) {
  return CATEGORY_CONFIG[categoryId] || null;
}
